import React from 'react';

const AddObject = () => {
  return (
    <div>AddObject</div>
  );
};

export default AddObject;
